import { HubSetting } from 'hs-resources/resources/HubSetting';
import { useResource, skipToken } from 'pulse/react';
import { useHttpClient } from '../../client/HttpClientContext';
const DEFAULT_SAVING_MODE = 'auto';
export const useSavingMode = (options = {}) => {
  const httpClient = useHttpClient();
  const {
    data,
    loading,
    error
  } = useResource(HubSetting, {
    httpClient,
    params: options.skip ? skipToken : {
      settingName: 'CRM:Properties:AutosaveMode'
    }
  });
  const savingMode = data === 'auto' || data === 'manual' ? data : DEFAULT_SAVING_MODE;
  return {
    data: savingMode,
    loading,
    error
  };
};